import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {runTrackingSafely} from "../../../tracking/utils/run_tracking_safely";
import {
    getAmplitudeInvestmentListingFiltersAppliedEventProperties,
    IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams
} from "./get_amplitude_investment_listing_filters_applied_event_properties";

export const trackAmplitudeInvestmentListingFiltersApplied = (params: IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams) => {
    // fired from a render effect on the offer page, so a throw here would take the whole property list down
    runTrackingSafely(
        () => trackAmplitudeEvent("listing_filters_applied", getAmplitudeInvestmentListingFiltersAppliedEventProperties(params)),
        "trackAmplitudeInvestmentListingFiltersApplied failed",
        params
    );
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {runTrackingSafely} from "../../../tracking/utils/run_tracking_safely";
import {
    getAmplitudeInvestmentListingFiltersAppliedEventProperties,
    IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams
} from "./get_amplitude_investment_listing_filters_applied_event_properties";

export const trackAmplitudeInvestmentListingFiltersApplied = (params: IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams) => {
    // fired from a render effect on the offer page, so a throw here would take the whole property list down
    runTrackingSafely(
        () => trackAmplitudeEvent("listing_filters_applied", getAmplitudeInvestmentListingFiltersAppliedEventProperties(params)),
        "trackAmplitudeInvestmentListingFiltersApplied failed",
        params
    );
};
